import { FileText, Download, Mic, Pin } from "lucide-react";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const hm = (iso) => new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
const kb = (n) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

export function MessageBubble({ m, mine, showName, seen, extra, onPin, pinned }) {
    const url = `${BASE}/chat/messages/${m.id}/file`;
    return (
        <div className={`group flex flex-col ${mine ? "items-end" : "items-start"}`} data-testid={`chat-msg-${m.id}`} id={`msg-${m.id}`}>
            <div className={`relative max-w-[80%] sm:max-w-[65%] rounded-2xl px-3.5 py-2 shadow-sm ${mine ? "bg-klein text-white rounded-br-md" : "bg-white text-ink border border-ink/10 rounded-bl-md"} ${pinned ? "ring-2 ring-amber-400" : ""}`}>
                {onPin && (
                    <button onClick={onPin} title={pinned ? "Unpin" : "Pin to top"} data-testid={`chat-pin-btn-${m.id}`}
                        className={`absolute -top-2 ${mine ? "-left-2" : "-right-2"} w-7 h-7 rounded-full bg-white border border-ink/15 text-amber-700 shadow flex items-center justify-center transition-opacity ${pinned ? "opacity-100" : "opacity-60 sm:opacity-0 sm:group-hover:opacity-100"}`}>
                        <Pin className="w-3.5 h-3.5" />
                    </button>
                )}
                {showName && !mine && <div className="text-[11px] font-semibold text-klein mb-0.5">{m.sender_name}</div>}
                {m.kind === "image" && (
                    <a href={url} target="_blank" rel="noreferrer"><img src={url} alt={m.attachment.name} className="rounded-xl max-h-72 min-w-[120px] min-h-[80px] object-cover mb-1 bg-ink/5 border border-ink/10" data-testid={`chat-msg-image-${m.id}`} /></a>
                )}
                {m.kind === "voice" && (
                    <div className="flex items-center gap-2 mb-1 min-w-[220px]" data-testid={`chat-msg-voice-${m.id}`}>
                        <Mic className="w-4 h-4 shrink-0 opacity-80" />
                        <audio controls preload="metadata" src={url} className="h-9 flex-1 min-w-0" />
                        <span className="text-[11px] opacity-75 tabular-nums">{Math.floor((m.attachment.duration || 0) / 60)}:{String((m.attachment.duration || 0) % 60).padStart(2, "0")}</span>
                    </div>
                )}
                {m.kind === "file" && (
                    <a href={url} className={`flex items-center gap-2.5 rounded-xl p-2 mb-1 ${mine ? "bg-white/15" : "bg-ink/5"}`} data-testid={`chat-msg-file-${m.id}`}>
                        <FileText className="w-5 h-5 shrink-0" />
                        <span className="min-w-0 flex-1"><span className="block text-sm truncate">{m.attachment.name}</span><span className="text-[11px] opacity-70">{kb(m.attachment.size)}</span></span>
                        <Download className="w-4 h-4 shrink-0" />
                    </a>
                )}
                {m.text && <div className="text-sm whitespace-pre-wrap break-words">{m.text}</div>}
                <div className={`mt-0.5 text-[10px] text-right ${mine ? "text-white/70" : "text-ink/40"}`}>
                    {hm(m.created_at)}{seen && <span className="ml-1.5 font-semibold" data-testid="chat-msg-seen">· {seen}</span>}
                </div>
            </div>
            {extra}
        </div>
    );
}

export default MessageBubble;
